import { executeRequest, JFSRequest } from '@jfs/network'
import { dateFormatter, DateFormatTypes } from '@jfs/utils'
import { RootStore } from '../data/store'
import { isSuccessResponse } from './../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const checkForNull = (key: any) => {
  if (key) {
    if (key !== null) {
      return key
    }
    return ''
  }
  return ''
}

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return {
    ...data,
    content: data?.content?.map((item: any) => {
      return {
        ID: item?.id ?? '',
        name: item?.username ?? '',
        type: item?.type ?? '',
        group: `${item?.group?.name ?? ''}`,
        accessConfig: '',
        lastLogin: item?.lastUsed
          ? dateFormatter(new Date(item?.lastUsed), DateFormatTypes.DATE_STRING_TIME)
          : 'Not yet logged in',
        createdBy: checkForNull(item?.createdBy),
        createdDate: dateFormatter(new Date(item?.createdDate), DateFormatTypes.DATE_STRING_TIME),
        status: item?.isActive ? 'Active' : 'InActive',
      }
    }),
  }
}

const getAllUsers = (data: any, paginationInfo: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getAllUsers),
    method: 'POST',
    cache: false,
    config: sitConfig(RootStore.session.getTokens),
    headers: getHeaders(),
    body: {
      inputFilter: { ...data, ...(data?.isActive && { isActive: data?.isActive === 'Active' ? true : false }) },
      configParams: paginationInfo,
    },
  }

  return executeRequest(request)
    .then((resp) => responseParser(resp))
    .catch((error) => {
      throw error
    })
}

export { getAllUsers }
